// JS
import React from 'react';
import { randomId } from '../shared/utils';

// COMPONENT
const Button = ({
  gaBlockTitle,
  gaBlockName,
  gaBlockId,
  buttonColour = 'white',
  buttonGroup = false,
  buttonLink,
  buttonLinkText,
  buttonAdditionalClasses,
  buttonSlotNumber = 1,
  heroWithTextButton,
  buttonOptions,
  whiteSolidOptions
}) => {
  const uniqueId = randomId();
  const gaTracking = gaBlockTitle && gaBlockName && gaBlockId;
  const buttonColours = {
    white: `block w-full lg:w-auto h-auto py-5 px-12 text-md text-white text-center font-bold uppercase border border-solid border-white bg-transparent transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:!text-black group-hover:!bg-white'
        : 'hover:!text-black hover:!bg-white'
    } tracking-widest`,
    black: `block w-full lg:w-auto h-auto py-5 px-12 text-md text-black text-center font-bold uppercase border border-solid border-black bg-transparent transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:text-white group-hover:!bg-black'
        : 'hover:text-white hover:!bg-black'
    } tracking-widest`,
    whiteSolid: `block w-full md:w-auto h-auto text-black text-center font-bold bg-white transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:text-white group-hover:!bg-black'
        : 'hover:text-white hover:!bg-black'
    } ${
      whiteSolidOptions
        ? 'py-[30px] px-[36px] md:py-5 md:px-12 text-md uppercase border border-solid border-black tracking-widest'
        : 'py-5 px-12 text-lg'
    }`,
    purple: `block w-full lg:w-auto h-auto py-5 px-12 text-md text-[#6E80D0] text-center font-bold uppercase border border-solid border-[#6E80D0] bg-transparent transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:text-[#C4FBEE] group-hover:!bg-[#6E80D0]'
        : 'hover:text-[#C4FBEE] hover:!bg-[#6E80D0]'
    } tracking-widest`,
    grey: `block w-full lg:w-auto h-auto py-5 px-12 text-md text-white text-center font-bold uppercase border border-solid border-[#515452] bg-[#515452] bg-opacity-80 transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:text-[#515452] group-hover:!bg-transparent'
        : 'hover:text-[#515452] hover:!bg-transparent'
    } tracking-widest`
  };

  return (
    <div
      className={
        heroWithTextButton
          ? 'flex justify-end w-full md:w-auto'
          : 'flex justify-center' +
            (buttonOptions?.classes?.wrapper
              ? ' ' + buttonOptions.classes.wrapper
              : '')
      }
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          if (e.metaKey || e.ctrlKey) {
            window.open(buttonLink, '_blank');
          } else {
            window.open(buttonLink, '_self');
          }
        }}
        id={'button-id-' + uniqueId}
        className={
          buttonColours[buttonColour] +
          (buttonAdditionalClasses?.classes
            ? ' ' + buttonAdditionalClasses.classes
            : '')
        }
        data-name={gaTracking && gaBlockTitle}
        data-creative={gaTracking && gaBlockName}
        data-id={gaTracking && gaBlockId}
        data-position={gaTracking && 'button-slot-' + buttonSlotNumber}
        data-type={gaTracking && 'banner-button'}
      >
        {buttonLinkText}
      </button>
    </div>
  );
};

export default Button;
